import { render, staticRenderFns } from "./mfaPhonePrompt.vue?vue&type=template&id=ace2f120&scoped=true&"
import script from "./mfaPhonePrompt.vue?vue&type=script&lang=js&"
export * from "./mfaPhonePrompt.vue?vue&type=script&lang=js&"
import style0 from "./mfaPhonePrompt.vue?vue&type=style&index=0&id=ace2f120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace2f120",
  null
  
)

component.options.__file = "mfaPhonePrompt.vue"
export default component.exports